import MediaPartner from 'umg-ember-backend/components/record-explorer/for/media-partner';

<template>
  <MediaPartner @records={{@model}} @recordType='media-partner' />
</template>
